// @flow
import type { MembersActionTypes } from 'src/redux/actions/members/membersTypes'
import {
  GET_MEMBERS_BY_LEAGUE_ID,
  INVITE_MEMBER,
  REMOVE_MEMBER,
  CHANGE_OWNER,
} from 'src/redux/actions/members/members'

export type LeagueOwner = {
    email: string,
    first_name: string,
    last_name: string,
    role: string
};

export type MemberItem = {
    account_id: number,
    email: string,
    first_name: string,
    last_name: string,
    role: string
};

export type MembersDataItem = {
    leagueOwner: LeagueOwner,
    members: MemberItem[]
};
export type MembersData = {
    total: number,
    offset: number,
    limit: number,
    page: number,
    results: MembersDataItem
};

export type MembersState = {
  isLoading: boolean,
  membersData: ?MembersData,
  membersErrors?: ?{ [key: string]: any } | ?string,
  currentMemberData: ?MembersDataItem
};

const initialState = {
  isLoading: false,
  membersData: null,
  membersErrors: null,
  currentMemberData: null,
}

const members = (state: MembersState = initialState, action: MembersActionTypes): MembersState => {
  switch (action.type) {
    case GET_MEMBERS_BY_LEAGUE_ID.REQUEST:
    case INVITE_MEMBER.REQUEST:
    case REMOVE_MEMBER.REQUEST:
    case CHANGE_OWNER.REQUEST:
    {
      return {
        ...state,
        isLoading: true,
      }
    }

    case GET_MEMBERS_BY_LEAGUE_ID.SUCCESS:
    {
      return ({
        ...state,
        isLoading: false,
        membersData: { ...action.payload },
        membersErrors: null,
      })
    }

    case CHANGE_OWNER.SUCCESS:
    case REMOVE_MEMBER.SUCCESS:
    {
      return ({
        ...state,
        isLoading: false,
        membersErrors: null,
      })
    }

    case INVITE_MEMBER.SUCCESS:
    {
      return ({
        ...state,
        isLoading: false,
        membersErrors: null,
      })
    }

    case GET_MEMBERS_BY_LEAGUE_ID.FAILURE:
    case INVITE_MEMBER.FAILURE:
    case REMOVE_MEMBER.FAILURE:
    {
      return { ...state, isLoading: false, membersErrors: action.payload }
    }
    case CHANGE_OWNER.FAILURE:
    {
      return { ...state, isLoading: false }
    }
    default: {
      return state
    }
  }
}

export default members
